import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { updateReport } from "./reportedHotspotApi";

const BatchUpdateModal = ({ isOpen, toggle, selectedReports, onUpdate }) => {
  const [state, setState] = useState("");
  const [adminNote, setAdminNote] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedReports || selectedReports.length === 0) {
      alert("No reports selected");
      return;
    }

    if (!state && !adminNote.trim()) {
      alert("Please provide either a state or admin note");
      return;
    }

    setLoading(true);
    try {
      const reportIds = selectedReports.map(r => r.report_id);
      
      const updateData = {
        report_ids: reportIds,
      };

      // Only include state if provided
      if (state) {
        updateData.state = state;
      }

      // Only include adminNote if it has content
      if (adminNote && adminNote.trim()) {
        updateData.adminNote = adminNote.trim();
      }

      await updateReport(updateData);

      // Call onUpdate callback to refresh the reports list
      if (onUpdate) {
        onUpdate();
      }

      // Reset form
      setState("");
      setAdminNote("");
      toggle();
    } catch (error) {
      console.error("Error updating reports:", error);
      alert(error.response?.data?.message || error.message || "Failed to update reports");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setState("");
    setAdminNote("");
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={handleClose}>
          <i className="mdi mdi-checkbox-multiple-marked me-2"></i>
          Batch Update ({selectedReports?.length || 0} reports)
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <small className="text-muted">
              Update {selectedReports?.length || 0} selected report(s)
            </small>
          </div>

          <FormGroup>
            <Label>State (Optional)</Label>
            <Input
              type="select"
              value={state}
              onChange={(e) => setState(e.target.value)}
            >
              <option value="">-- Keep Current State --</option>
              <option value="raised">Raised</option>
              <option value="inProgress">In Progress</option>
              <option value="resolved">Resolved</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>Admin Note (Optional)</Label>
            <Input
              type="textarea"
              rows="4"
              value={adminNote}
              onChange={(e) => setAdminNote(e.target.value)}
              placeholder="Enter admin note for all selected reports..."
            />
          </FormGroup>

          <div className="alert alert-info mb-0">
            <small>
              <i className="mdi mdi-information me-1"></i>
              Leave fields empty to keep current values. At least one field must be provided.
            </small>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading || !state && !adminNote.trim()}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Updating...
              </>
            ) : (
              <>
                <i className="mdi mdi-check me-2"></i>
                Update {selectedReports?.length || 0} Report(s)
              </>
            )}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default BatchUpdateModal;

